export default __webpack_public_path__ + "static/media/bg1.f045d246.jpg";